// Base
import Head from 'next/head'
import { GetStaticProps } from 'next'

// Redux
import { useAppSelector } from '@redux/hooks'

// Helpers
import { publicFetch } from '@helpers/contentAPI'

// Components
import Header from '@components/common/header/Header'

//Sections
import Homepage from '@sections/homepage/Homepage'
import Media from '@sections/media/Media'
import Box from '@components/helpers/box/Box'

export default function Home() {
  const { social } = useAppSelector((state) => state.staticProps)

  return (
    <>
      <Head>
        <title>{social.title}</title>
        <meta name="description" content={social.description} />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <link rel="icon" href="/favicon.ico" />
        <meta property="og:url" content="https://premium.ratepunk.com/" />
        <meta property="og:type" content="website" />
        <meta property="og:title" content={social.title} />
        <meta property="og:description" content={social.description} />
        <meta property="og:image" content={social?.image?.url} />
        <meta name="twitter:card" content="summary_large_image" />
        <meta property="twitter:domain" content="premium.ratepunk.com" />
        <meta property="twitter:url" content="https://premium.ratepunk.com/" />
        <meta name="twitter:title" content={social.title} />
        <meta name="twitter:description" content={social.description} />
        <meta name="twitter:image" content={social?.image?.url} />
      </Head>

      <Header />

      <main>
        <Box backgroundColor="beige">
          <Homepage />

          <Media />
        </Box>
      </main>
    </>
  )
}

export const getStaticProps: GetStaticProps = async () => {
  try {
    const social = await publicFetch({
      url: '/api/social',
      params: {
        populate: 'image'
      }
    })
    const faq = await publicFetch({
      url: '/api/faq',
      params: {
        populate: 'homepage'
      }
    })
    const flightDeals = await publicFetch({
      url: '/api/selected-flight-deal',
      params: {
        populate: {
          flightDeals: {
            populate: {
              departure: true,
              arrival: {
                populate: {
                  city: {
                    populate: 'image'
                  }
                }
              }
            }
          }
        }
      }
    })

    return {
      props: {
        initialReduxState: {
          staticProps: {
            social: social.data,
            faq: faq.data.homepage,
            flightDeals: flightDeals.data.flightDeals
          }
        }
      }
    }
  } catch {
    return {
      props: {
        initialReduxState: {
          staticProps: {
            social: {
              title: '',
              description: '',
              image: { url: '' } 
            },
            faq: [],
            flightDeals: []
          }
        }
      }
    }
  }
}
